export default __webpack_public_path__ + "static/media/watch_2.5ed3bf0d.jpg";